import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ children, className, onClick }) => (
  <button className={`btn ${className}`} onClick={onClick} type="button">
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  className: 'btn-primary',
  onClick: () => {},
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js